export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  CONVERSATION_SETTINGS_V2: 'conversation_settings_v2',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  WHATSAPP_TEMPLATE_MANAGEMENT: 'whatsapp_template_management',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  META_BUSINESS_ACCOUNTS: 'meta_business_accounts',
  PAID_ADS: 'paid_ads',
  META_ADS: 'meta_ads',
  TIKTOK_ADS: 'tiktok_ads',
  TIKTOK_MESSAGING_ADS: 'tiktok_messaging_ads',
  GOOGLE_ADS: 'google_ads',
  GOOGLE_CALENDAR: 'google_calendar_integration',
  GOOGLE_CALENDAR_BOOKING: 'google_calendar_booking',
  GOOGLE_SHEETS: 'google_sheets_integration',
  WORKSPACE_CALENDAR: 'workspace_calendar',
  CALENDAR_BOOKING: 'calendar_booking',
  SHOPIFY: 'shopify_integration',
  SHOPIFY_AUTOMATION: 'shopify_automation',
  SHOPIFY_AI: 'shopify_ai',
  SHOPIFY_COD: 'shopify_cod',
  SHOPIFY_RECOVERY: 'shopify_recovery',
  EASYORDERS: 'easyorders_integration',
  SALLA: 'salla_integration',
  ZID: 'zid_integration',
  COMMERCE_AUTOMATION: 'commerce_automation',
  COMMERCE_AI: 'commerce_ai',
  COMMERCE_COD: 'commerce_cod',
  COMMERCE_RECOVERY: 'commerce_recovery',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_TASKS: 'captain_tasks',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
  FEATURE_FLAGS.META_BUSINESS_ACCOUNTS,
];
